module.exports = __webpack_public_path__ + "img/cad.483720eb.png";